import { TFunction } from 'i18next';
import * as Yup from 'yup';
import { CANCELLATION_DESCRIPTION_MIN_LENGTH } from './SubscriptionManager.constants';

export function CancelSubscriptionSchema(
  t: TFunction<'settings/SubscriptionManager', undefined>,
) {
  return Yup.object({
    cancellationReason: Yup.string().required(
      t('cancelSubscription.form.validation.required'),
    ),
    description: Yup.string().when('cancellationReason', {
      is: (value: string) => Boolean(value),
      then: (schema) =>
        schema
          .required(t('cancelSubscription.form.validation.descriptionRequired'))
          .min(
            CANCELLATION_DESCRIPTION_MIN_LENGTH,
            t('cancelSubscription.form.validation.descriptionMinLength'),
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
}
